import { IPutAfterConfirmingBookingWorkflowRequest } from '@/types/workflows/IPutAfterConfirmingBookingWorkflowRequest';
import { UseFormReturn } from 'react-hook-form';
import OptionsCreateEvent from '../options-create-event/options-create-event.view';
import { OptionsCreateOOOEvent } from '../options-create-event/options-create-ooo-event.view';
import OptionsWebinar from '../options-create-event/options-webinar';

interface IProps {
	index: number;
	type: string;
	form: UseFormReturn<IPutAfterConfirmingBookingWorkflowRequest, any>;
}

export default function ActionOptions(props: IProps) {
	switch (props.type) {
		case 'webinar':
			return <OptionsWebinar index={props.index} form={props.form} />;
		case 'calendar-event':
			return <OptionsCreateEvent index={props.index} form={props.form} />;
		case 'ooo-event':
			return <OptionsCreateOOOEvent index={props.index} form={props.form} />;
	}
}
